import { useEffect, useState } from "react";
import { fetchWithAuth } from "../../../../../api-client/api_client";
import { showErrorToast } from "../../../../shared/Toasts";

type AutomatedTestRegistryResponse = {
  has_tests: boolean;
  integration_version_id: string | null;
};

interface Params {
  integrationID: string;
}

const useCheckAutomatedTestRegistry = ({ integrationID }: Params) => {
  // state
  const [hasTests, setHasTests] = useState<boolean>(false);
  const [integrationVersionId, setIntegrationVersionId] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const fetchData = () => {
    if (!integrationID) {
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);

    fetchWithAuth({
      path: `/integrations/${integrationID}/test-registry`,
      method: "GET",
      body: {},
      expectJSON: true,
      onResponse: (data: AutomatedTestRegistryResponse) => {
        setHasTests(data.has_tests);
        setIntegrationVersionId(data.integration_version_id);
        setLoading(false);
      },
      onError: (error) => {
        setLoading(false);
        setError("Failed to check automated test registry");
        setHasTests(false);
        setIntegrationVersionId(null);
        error
          ?.json()
          .then((value: string | Record<string, any>) => {
            let errorMessage = "";
            if (typeof value == "string") {
              errorMessage = value;
            } else {
              errorMessage = value?.non_field_errors ?? JSON.stringify(value);
            }
            showErrorToast(
              `Failed to check automated test registry. Error message: \n ${errorMessage}`
            );
          })
          .catch(() => {
            showErrorToast("Failed to check automated test registry");
          });
      },
    });
  };

  // effects
  // fetch data on mount and when integrationID changes
  useEffect(() => {
    fetchData();
  }, [integrationID]);

  return {
    hasTests,
    integrationVersionId,
    loading,
    error,
  };
};

export default useCheckAutomatedTestRegistry;
